import {vHelp} from '@/plugins/help/help';

const help = {
    install(app) {
        app.directive('help', vHelp);
    }
};

export default help;